// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-gallery-container {
  height: inherit;
}
.media-gallery-container.waggle {
  margin: 0px;
  display: flex;
  width: 100%;
}
.media-gallery-container.waggle .gallery {
  min-height: 240px;
  display: flex;
  width: 100%;
  gap: 8px;
}
.media-gallery-container.waggle .gallery > div.horizontal {
  column-gap: 8px;
}
.media-gallery-container .more-media {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #2A2A2A;
  margin: 0;
  position: absolute;
  bottom: 16px;
  right: 180px;
  padding: 8px 16px;
  z-index: 2;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.media-gallery-container .more-media:hover {
  background-color: #3e3e3e;
}
.media-gallery-container .more-media p {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: white;
  margin: 0;
  margin-left: 8px;
}
.media-gallery-container .more-count {
  margin: 0;
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translate(-50%, -20%);
  font-weight: 700;
  font-size: 18px;
  color: white;
  letter-spacing: 5px;
  z-index: 2;
}
.media-gallery-container .gallery {
  height: 100%;
  display: flex;
  gap: 16px;
}
.media-gallery-container .gallery > div {
  position: relative;
}
.media-gallery-container .gallery > div:first-child {
  display: flex;
  flex: 1 1;
}
.media-gallery-container .gallery > div:first-child.more {
  flex: 1.5 1;
}
.media-gallery-container .gallery > div:last-child {
  display: flex;
  flex: 1 1;
}
.media-gallery-container .gallery > div.horizontal {
  column-gap: 16px;
}
.media-gallery-container .gallery > div.vertical {
  flex-direction: column;
}
.media-gallery-container .gallery > div.vertical > img,
.media-gallery-container .gallery > div.vertical > video {
  margin: 15px 0;
  flex: 1 1;
}
.media-gallery-container .gallery > div.vertical > img:first-child,
.media-gallery-container .gallery > div.vertical > video:first-child {
  margin-bottom: 5px;
  margin-top: 0px;
}
.media-gallery-container .gallery > div.vertical > img:last-child,
.media-gallery-container .gallery > div.vertical > video:last-child {
  margin-bottom: 0px;
  margin-top: 5px;
}
.media-gallery-container .gallery > div > img,
.media-gallery-container .gallery > div > video {
  width: 100%;
  border-radius: 16px;
  object-fit: cover;
  overflow: hidden;
}
.media-gallery-container .gallery > div > img.grayscale,
.media-gallery-container .gallery > div > video.grayscale {
  filter: brightness(0.7);
}
.media-gallery-container .gallery > div > video {
  object-fit: contain;
}
.media-gallery-container .gallery.mix {
  flex-direction: column;
}
.media-gallery-container .gallery.mix > div {
  max-height: 240px;
}
.media-gallery-container .gallery.mix > div:first-child {
  max-height: 315px;
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .media-gallery-container .more-media {
    right: 80px;
  }
  .media-gallery-container .more-media p {
    display: none;
  }
  .media-gallery-container .gallery.mix > div:first-child {
    flex: none;
    max-height: none;
    height: 400px;
    object-fit: cover;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MediaGallery/mediaGallery.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ;AAGI;EACI,WAAA;EACA,aAAA;EACA,WAAA;AADR;AAEQ;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,QAAA;AAAZ;AAEgB;EACI,eAAA;AAApB;AAMI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;EACA,4BAAA;AAJR;AAMQ;EACI,yBAAA;AAJZ;AAOQ;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AALZ;AASI;EACI,SAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AAPR;AAUI;EACI,YAAA;EACA,aAAA;EACA,SAAA;AARR;AAUQ;EACI,kBAAA;AARZ;AAUY;EACI,aAAA;EACA,SAAA;AARhB;AAUgB;EACI,WAAA;AARpB;AAYY;EACI,aAAA;EACA,SAAA;AAVhB;AAaY;EACI,gBAAA;AAXhB;AAcY;EACI,sBAAA;AAZhB;AAcgB;;EAEI,cAAA;EACA,SAAA;AAZpB;AAcoB;;EACI,kBAAA;EACA,eAAA;AAXxB;AAcoB;;EACI,kBAAA;EACA,eAAA;AAXxB;AAgBY;;EAEI,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAdhB;AAgBgB;;EACI,uBAAA;AAbpB;AAgBY;EACI,mBAAA;AAdhB;AAkBQ;EACI,sBAAA;AAhBZ;AAiBY;EACI,iBAAA;AAfhB;AAgBgB;EACI,iBAAA;AAdpB;AClHY;EDiJJ;IACI,WAAA;EA5BV;EA6BU;IACI,aAAA;EA3Bd;EAiCkB;IACI,UAAA;IACA,gBAAA;IACA,aAAA;IACA,iBAAA;EA/BtB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.media-gallery-container {\r\n    height: inherit;\r\n\r\n    &.waggle {\r\n        margin: 0px;\r\n        display: flex;\r\n        width: 100%;\r\n        .gallery {\r\n            min-height: 240px;\r\n            display: flex;\r\n            width: 100%;\r\n            gap: 8px;\r\n            > div {\r\n                &.horizontal {\r\n                    column-gap: 8px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .more-media {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        border-radius: 8px;\r\n        background-color: #2A2A2A;\r\n        margin: 0;\r\n        position: absolute;\r\n        bottom: 16px;\r\n        right: 180px;\r\n        padding: 8px 16px;\r\n        z-index: 2;\r\n        cursor: pointer;\r\n        transition: .2s ease-in-out;\r\n\r\n        &:hover {\r\n            background-color: #3e3e3e\r\n        }\r\n\r\n        p {\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-weight: 600;\r\n            font-size: 12px;\r\n            color: white;\r\n            margin: 0;\r\n            margin-left: 8px;\r\n        }\r\n    }\r\n\r\n    .more-count {\r\n        margin: 0;\r\n        position: absolute;\r\n        bottom: 20%;\r\n        left: 50%;\r\n        transform: translate(-50%, -20%);\r\n        font-weight: 700;\r\n        font-size: 18px;\r\n        color: white;\r\n        letter-spacing: 5px;\r\n        z-index: 2;\r\n    }\r\n\r\n    .gallery {\r\n        height: 100%;\r\n        display: flex;\r\n        gap: 16px;\r\n\r\n        >div {\r\n            position: relative;\r\n\r\n            &:first-child {\r\n                display: flex;\r\n                flex: 1;\r\n\r\n                &.more {\r\n                    flex: 1.5;\r\n                }\r\n            }\r\n\r\n            &:last-child {\r\n                display: flex;\r\n                flex: 1;\r\n            }\r\n\r\n            &.horizontal {\r\n                column-gap: 16px;\r\n            }\r\n\r\n            &.vertical {\r\n                flex-direction: column;\r\n\r\n                >img,\r\n                >video {\r\n                    margin: 15px 0;\r\n                    flex: 1;\r\n\r\n                    &:first-child {\r\n                        margin-bottom: 5px;\r\n                        margin-top: 0px;\r\n                    }\r\n\r\n                    &:last-child {\r\n                        margin-bottom: 0px;\r\n                        margin-top: 5px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            >img,\r\n            >video {\r\n                width: 100%;\r\n                border-radius: 16px;\r\n                object-fit: cover;\r\n                overflow: hidden;\r\n\r\n                &.grayscale {\r\n                    filter: brightness(.7);\r\n                }\r\n            }\r\n            > video {\r\n                object-fit: contain;\r\n            }\r\n        }\r\n\r\n        &.mix {\r\n            flex-direction: column;\r\n            >div {\r\n                max-height: 240px;\r\n                &:first-child {\r\n                    max-height: 315px;\r\n                }\r\n                &.horizontal {\r\n                    >img,\r\n                    >video {\r\n                        &:first-child {}\r\n\r\n                        &:last-child {}\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .media-gallery-container {\r\n        .more-media {\r\n            right: 80px;\r\n            p {\r\n                display: none;\r\n            }\r\n        }\r\n        .gallery {\r\n            &.mix {\r\n                >div {\r\n                    &:first-child {\r\n                        flex: none;\r\n                        max-height: none;\r\n                        height: 400px;\r\n                        object-fit: cover;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
